import * as types from './mutation-types';
import productionSchedule from '../../services/productionSchedule'
import { createServiceCall } from '../actionsUtil'

export const getProductionPlanningScheduleData = createServiceCall({
    mainAction: types.GET_PRODUCTION_SCHEDULE_DATA_REQUEST,
    serviceFunction: productionSchedule.getProductionPlanningScheduleData,
    successAction: types.GET_PRODUCTION_SCHEDULE_DATA_SUCCESS,
    successDataProperty: "",
    failureAction: types.GET_PRODUCTION_SCHEDULE_DATA_FAILURE
  });

export const saveProductionSchedule = createServiceCall({
    mainAction: types.SAVE_PRODUCTION_SCHEDULE_REQUEST,
    serviceFunction: productionSchedule.saveProductionSchedule,
    successAction: types.SAVE_PRODUCTION_SCHEDULE_SUCCESS,
    successDataProperty: 'saveScheduleHistory',
    failureAction: types.SAVE_PRODUCTION_SCHEDULE_FAILURE
});

export const getProductionScheduleHistory = createServiceCall({
    mainAction: types.GET_PRODUCTION_SCHEDULE_HISTORY_REQUEST,
    serviceFunction: productionSchedule.getProductionScheduleHistory,
    successAction: types.GET_PRODUCTION_SCHEDULE_HISTORY_SUCCESS,
    successDataProperty: '',
    failureAction: types.GET_PRODUCTION_SCHEDULE_HISTORY_FAILURE
  });

export const saveProductionScheduleOnDynamoDB = createServiceCall({
    mainAction: types.SAVE_PRODUCTION_SCHEDULE_HISTORY_ON_DYNAMO_DB_REQUEST,
    serviceFunction: productionSchedule.saveProductionScheduleOnDynamoDB,
    successAction: types.SAVE_PRODUCTION_SCHEDULE_HISTORY_ON_DYNAMO_DB_SUCCESS,
    successDataProperty: '',
    failureAction: types.SAVE_PRODUCTION_SCHEDULE_HISTORY_ON_DYNAMO_DB_FAILURE
});

export const deleteProductionScheduleOnDynamoDB = createServiceCall({
    mainAction: types.DELETE_PRODUCTION_SCHEDULE_HISTORY_ON_DYNAMO_DB_REQUEST,
    serviceFunction: productionSchedule.deleteProductionScheduleOnDynamoDB,
    successAction: types.DELETE_PRODUCTION_SCHEDULE_HISTORY_ON_DYNAMO_DB_SUCCESS,
    successDataProperty: '',
    failureAction: types.DELETE_PRODUCTION_SCHEDULE_HISTORY_ON_DYNAMO_DB_FAILURE
});

export const reloadProductionSchedule = createServiceCall({
    mainAction: types.RELOAD_PRODUCTION_SCHEDULE_HISTORY_REQUEST,
    serviceFunction: productionSchedule.reloadProductionSchedule,
    successAction: types.RELOAD_PRODUCTION_SCHEDULE_HISTORY_SUCCESS,
    successDataProperty: 'productionScheduleHistory',
    failureAction: types.RELOAD_PRODUCTION_SCHEDULE_HISTORY_FAILURE
});

export const deleteProductionSchedule = createServiceCall({
    mainAction: types.DELETE_PRODUCTION_SCHEDULE_REQUEST,
    serviceFunction: productionSchedule.deleteProductionSchedule,
    successAction: types.DELETE_PRODUCTION_SCHEDULE_SUCCESS,
    successDataProperty: '',
    failureAction: types.DELETE_PRODUCTION_SCHEDULE_FAILURE
});

export const schedule = createServiceCall({
    mainAction: types.SCHEDULE_REQUEST,
    serviceFunction: productionSchedule.schedule,
    successAction: types.SCHEDULE_SUCCESS,
    successDataProperty: 'schedule',
    failureAction: types.SCHEDULE_FAILURE
});
